import { BookitlabLogo } from 'app/components/BookitlabLogo';
import { BookitlabShortLogo } from 'app/components/BookitlabLogo/BookitlabShortLogo';
import { selectMinimizedBookitlabLogo } from 'app/slice/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { DetectIsMobile } from 'utils/mobileDetect';
import { CustomerLogo } from '../../CustomerLogo';
import clsx from 'clsx';
import { ToggleSideMenuButton } from '../../TopBar/components/ToggleSideMenuButton';
import { UserProfileMobile } from '../UserProfileMobile';

export interface SideBarHeaderProps {
  children?: React.ReactNode;
  isOpen: boolean;
}

export const SideBarHeader = React.memo(function SideBarHeader(
  props: SideBarHeaderProps,
) {
  const { children, isOpen } = props;
  const isMobile = DetectIsMobile();
  const logoMinimized = useSelector(selectMinimizedBookitlabLogo);
  return (
    <React.Fragment>
      <div
        className={clsx('sideBarHeader', {
          sideBarHeaderOpen: isOpen,
          sideBarHeaderMobile: isMobile,
        })}
      >
        {isMobile ? (
          <CustomerLogo height="24" width="90" />
        ) : isOpen && !logoMinimized ? (
          <BookitlabLogo size="80x24" />
        ) : (
          <BookitlabShortLogo />
        )}
        <div
          className={clsx('headerButtons', { headerButtonsMobile: isMobile })}
        >
          {isMobile && isOpen && <UserProfileMobile />}

          {/* {isMobile && isOpen && showSearchInSidebar && (
            <div
              style={{
                padding: '0px 16px',
                display: 'flex',
                width: '100%',
                // flexFlow: 'column',
              }}
            >
              <AssetQuickSearch />
            </div>
          )} */}
          {/* {isMobile && isOpen && (
            <Box
              style={{
                padding: '8px 16px',
                display: 'flex',
                flexFlow: 'column',
              }}
            >
              <CoreSelectionButton />
            </Box>
          )} */}
          {isOpen && !isMobile && <ToggleSideMenuButton />}
        </div>
        {children}
      </div>
    </React.Fragment>
  );
});
